export enum CreateGroupStep {
  Undefined = 0,
  Definition = 1,
  UsersFromDomains = 2,
  FinalConfirmation = 3
}
